/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const SelectorGalleryImage = (props) => {
    
    const image = props?.image;
    const displayWidth = props?.displayWidth;
    const displayHeight = props?.displayHeight;
    
    const { url, cover_position = "center center" } = image || {};
    let { width = 0, height = 0 } = image || {};
    const defaultWidth = "100%";
    const defaultHeight = 160;
    // use defaults if 0
    width = (width === 0) ? defaultWidth : width;
    height = (height === 0) ? defaultHeight : height;
    // use display width/height if supplied
    width = displayWidth ? displayWidth : width;
    height = displayHeight ? displayHeight : height;
    const cover_image_style = {
        backgroundImage: `url('${url}')`,
        backgroundPosition: `${cover_position}`,
        width: width,
        height: height,
        borderRadius: "4px",
    };
    
    return (
        <div
            id='simplicity-cover-image'
            className='simplicity-cover-image-edit cover'
            style={cover_image_style}
        />
    );
};

export { SelectorGalleryImage };
